import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../store';

export const hasCatastrophicFailureOccurred = createSelector(
  (state: RootState) => state.lines,
  (state: RootState) => state.stations,
  (state: RootState) => state.trailers,
  (state: RootState) => state.truckDrivers,

  (lines, stations, trailers, truckDrivers) =>
    lines.status === 'catastrophicallyFailed' ||
    stations.status === 'catastrophicallyFailed' ||
    trailers.status === 'catastrophicallyFailed' ||
    truckDrivers.status === 'catastrophicallyFailed',
);
